// extracted by mini-css-extract-plugin
export default {"container":"ModifierComposante_container__b09gH","btn_stylo":"ModifierComposante_btn_stylo__coLVG"};